import { layoutOf } from "../../domain/layout";
import { dualAxle, singleAxle } from "../wheel-placements";
import {
  MIXER_10,
  MIXER_6,
  axleHalfTrack
} from "./dimensions";
const mixerWheels = (d) => d.axles.flatMap((axle, i) => {
  const spec = {
    axle: i + 1,
    x: axle.x,
    radius: d.wheelRadius,
    width: d.tyreWidth,
    halfTrack: axleHalfTrack(d, axle)
  };
  switch (axle.fitment) {
    case "single":
      return singleAxle(spec);
    case "dual":
      return dualAxle({ ...spec, spacing: d.dualSpacing });
    default: {
      const _exhaustive = axle.fitment;
      return _exhaustive;
    }
  }
});
const MIXER_10_LAYOUT = layoutOf(["single", "dual", "dual"]);
const MIXER_10_WHEELS = mixerWheels(MIXER_10);
const MIXER_6_LAYOUT = layoutOf(["single", "dual"]);
const MIXER_6_WHEELS = mixerWheels(MIXER_6);
export {
  MIXER_10_LAYOUT,
  MIXER_10_WHEELS,
  MIXER_6_LAYOUT,
  MIXER_6_WHEELS
};
